{
	"labels": {
		"tuje": "tuje letalo?",
		"reg":"Registracija",
		"masa_plovila": "Teža plovila",
		"klub":"Izberi klub :",
		"stUr":"Število ur :",
		"stLetov": "Število letov:",
		"datumN":"Datum Nakupa :",
		"datumR":"Datum registracije :",
		"vrsta":"Izberi vrsto :",
		"vlecno":"Vlečno:",
		"vlecnoD":"Da",
		"vlecnoN":"Ne",
		"opomba":"Opomba",
		"obracunStevec": "Beleženje 'Flight' časa:",
		"razpolozljivost": "Prikaz v razpoložljivosti:",
		"camo_pregled": "Prikaz v CAMO:",
		"camo_flight": "Prikaz 'Flight' časa v CAMO:"
	},
	"buttons": {
		"vnos": "Vnesi zapis",
		"brisiIzbiro": "Pobriši izbiro"
	}
}